import React, { useEffect, useRef, useState, type FC } from 'react';

interface SkeletonProps {
    className?: string;
}

export const Skeleton: FC<SkeletonProps> = ({ className }) => {
    return <div className={`${className} animate-pulse bg-gray-90 rounded-full`} />;
};
